import React, { useCallback, useState } from 'react';
import moment from 'moment';

import { Trans, useTranslation } from 'react-i18next';

import { ContactUsModal } from '../../../sideMenu/contactUs/ContactUsModal';
import {
  CONTACT_US_STEPS,
} from '../../../sideMenu/contactUs/contactUs.constants';

import '../css/CancelRenewalSent.css';

const CancelRenewalSuccess = ({ onReturnClick = () => { }, renewalDate }) => {
  const { t } = useTranslation('changeCoverage');
  const [contactUsVisible, setContactUsVisible] = useState(false);

  const onContactUsClick = useCallback(() => {
    setContactUsVisible((prevState) => !prevState);
  }, []);

  const ContactUsButton = () => (
    <button
      className="Cancel-renewal-sent-contact-us"
      onClick={onContactUsClick}
      type="button"
    >
      <span>{t('options.cancelRenewalContactUs')}</span>
    </button>
  );

  function formatDate(date) {
    return !date ? '-' : moment(date.split('T')[0]).format('MM/DD/YYYY');
  }

  return (
    <>
      <div className="Cancel-renewal-sent-container">
        <h3>{t('options.successfullyCancelled')}</h3>

        <div className="Cancel-renewal-sent-description">
          <Trans
            components={{ bold: <strong />, button: <ContactUsButton /> }}
            i18nKey="options.successfullyCancelledDescription"
            t={t}
            values={{
              renewalDate: formatDate(renewalDate),
            }}
          />
        </div>

        <button
          className="Cancel-renewal-sent-return-btn"
          onClick={onReturnClick}
          type="button"
        >
          {t('preview.returnToInsurance')}
        </button>
      </div>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.FIGO}
        onClose={onContactUsClick}
        show={contactUsVisible}
      />
    </>
  );
};

export { CancelRenewalSuccess };
